import React from "react";
import { HiOutlineGlobeAmericas, HiOutlineShieldCheck, HiOutlineUserGroup, HiOutlineArrowRight } from "react-icons/hi2";
import { MdOutlineSupportAgent, MdOutlineAutoAwesome } from "react-icons/md";
import "../asset/css/about.css";
import img1 from "../asset/img/img1.jpg";
const About = () => {
  return (
    <div className="about-page">
      {/* Dynamic Hero Section */}
      <section className="about-hero-slick">
        <div className="container">
          <div className="hero-content-box animate-fade-in">
            <span className="tagline">SINCE 2010</span>
            <h1 className="display-2 fw-bold">Redefining <br/> <span className="text-outline">The Way You Travel</span></h1>
            <p className="mt-3">We don't just book trips; we curate life-changing moments.</p>
          </div>
        </div>
      </section>

      {/* Overlapping Content Section */}
      <section className="container py-5 position-relative mb-5">
        <div className="row g-0 align-items-center">
          <div className="col-lg-7">
            <div className="main-image-wrapper">
              <img 
                src={img1}
                alt="Adventure" 
                className="img-main shadow-2xl"
              />
              <div className="floating-card glass-morphism animate-bounce-slow">
                <MdOutlineAutoAwesome className="fs-1 text-teal mb-2" />
                <h5>Best Agency 2024</h5>
                <p className="small mb-0">Recognized</p>
              </div>
            </div>
          </div>
          <div className="col-lg-5 content-overlap">
            <div className="slick-card-text p-5 shadow-lg">
              <h6 className="text-teal fw-bold letter-spacing-2">WHO WE ARE</h6>
              <h2 className="display-6 fw-bold mb-4">Crafting Stories, <br/> Not Just Itineraries</h2>
              <p className="text-muted leading-relaxed">
                At **TopAir View**, we bridge the gap between imagination and reality. Our mission is to provide seamless, luxurious, and soulful travel experiences across 7 continents.
              </p>
              <ul className="slick-list mt-4">
                <li><HiOutlineArrowRight className="text-teal me-2"/> 100% Tailor-made journeys</li>
                <li><HiOutlineArrowRight className="text-teal me-2"/> Hand-picked premium accommodations</li>
                <li><HiOutlineArrowRight className="text-teal me-2"/> Sustainable & Conscious Tourism</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Grid Features Section */}
      <section className="bg-light-slick py-5">
        <div className="container py-5">
          <div className="row g-4">
            <div className="col-md-4">
              <div className="feature-card-slick">
                <div className="f-icon"><HiOutlineGlobeAmericas /></div>
                <h4>Unlimited Borders</h4>
                <p>Access to over 150+ countries with exclusive local partnerships.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="feature-card-slick active">
                <div className="f-icon"><MdOutlineSupportAgent /></div>
                <h4>VIP Concierge</h4>
                <p>Not just support, but a dedicated travel butler available 24/7.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="feature-card-slick">
                <div className="f-icon"><HiOutlineShieldCheck /></div>
                <h4>Elite Security</h4>
                <p>Your safety is our priority with real-time travel monitoring.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Slick Stats Bar */}
      {/* <section className="container my-5">
        <div className="stats-grid-slick shadow-xl">
          <div className="stat-item">
            <h3>12k+</h3>
            <span>Global Tours</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <h3>98%</h3>
            <span>Retention Rate</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <h3>25+</h3>
            <span>Awards Won</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <h3>15yr</h3>
            <span>Experience</span>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default About;